// Shape of a WhatsApp provider connection as the apps receive it (whatsapp-api through the
// Assistente IA API). Kept structural so both apps can pass their generated types.
export interface WhatsAppConnectionView {
  ownerId: string
  provider?: string | null
  status: string
  phoneNumber?: string | null
  displayName?: string | null
  lastCheckedAtUtc?: string | null
  lastError?: string | null
  webhookUrl?: string | null
  webhookVerifyToken?: string | null
  meta?: { phoneNumberId?: string | null; businessAccountId?: string | null; accessTokenHint?: string | null; appSecretHint?: string | null } | null
  zapi?: { instanceId?: string | null; instanceTokenHint?: string | null; clientTokenHint?: string | null } | null
  wafly?: { instanceId?: string | null; instanceTokenHint?: string | null; clientTokenHint?: string | null } | null
  wppConnect?: { sessionName?: string | null } | null
}

export type WhatsAppConnectionInput =
  | {
      provider: 'meta_cloud'
      meta: { phoneNumberId: string | null; businessAccountId: string | null; accessToken: string | null; appSecret: string | null }
    }
  | { provider: 'z_api'; zapi: { instanceId: string | null; instanceToken: string | null; clientToken: string | null } }
  | { provider: 'wafly'; wafly: { instanceId: string | null; instanceToken: string | null; clientToken: string | null } }
  | { provider: 'wpp_connect'; wppConnect: { sessionName: string | null } }

// Providers that pair a regular number by QR code (the others are registered at Meta).
export const QR_CODE_PROVIDERS: readonly string[] = ['z_api', 'wafly', 'wpp_connect']

// Tone of voice presets of the robot (AssistantRules.Tones in the backend).
export const ASSISTANT_TONES = [
  { value: 'formal', label: 'Formal', description: 'Linguagem cuidadosa, sem gírias, tratamento por "você" com cortesia.' },
  { value: 'friendly', label: 'Cordial', description: 'Próximo e educado, direto ao ponto.' },
  { value: 'casual', label: 'Descontraído', description: 'Leve e informal, pode usar emojis com moderação.' },
] as const

export const ASSISTANT_NAME_MAX = 25
export const ASSISTANT_TONE_INSTRUCTIONS_MAX = 500
